import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import * as z from 'zod';

import { BlogPosts } from '#features/blog/components/BlogPosts';

const blogSearchSchema = z.object({
  tag: z.string().optional(),
});

export const Route = createFileRoute('/{-$locale}/_layout/blog/')({
  validateSearch: zodValidator(blogSearchSchema),
  component: BlogPosts,
});
